import { render } from "./DiscountBasTab.vue?vue&type=template&id=fe2f4c24&scoped=true"
import script from "./DiscountBasTab.vue?vue&type=script&lang=js"
export * from "./DiscountBasTab.vue?vue&type=script&lang=js"

import "./DiscountBasTab.vue?vue&type=style&index=0&id=fe2f4c24&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fe2f4c24"]])

export default __exports__